import React, { Fragment, lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
const OnboardingFlow = lazy(() => import('../pages/OnboardingFlow').then(m => ({
  default: m.OnboardingFlow
})));
const DashboardPage = lazy(() => import('../pages/DashboardPage').then(m => ({
  default: m.DashboardPage
})));
const UploadPage = lazy(() => import('../pages/UploadPage').then(m => ({
  default: m.UploadPage
})));
const AnalysisPage = lazy(() => import('../pages/AnalysisPage').then(m => ({
  default: m.AnalysisPage
})));
const ProfilePage = lazy(() => import('../pages/ProfilePage').then(m => ({
  default: m.ProfilePage
})));
const AllScansPage = lazy(() => import('../pages/AllScansPage').then(m => ({
  default: m.AllScansPage
})));
const SettingsPage = lazy(() => import('../pages/SettingsPage').then(m => ({
  default: m.SettingsPage
})));
const MonthlyReportPage = lazy(() => import('../pages/MonthlyReportPage').then(m => ({
  default: m.MonthlyReportPage
})));
const PremiumToolsPage = lazy(() => import('../pages/PremiumToolsPage').then(m => ({
  default: m.PremiumToolsPage
})));
const MessageRewriterPage = lazy(() => import('../pages/MessageRewriterPage').then(m => ({
  default: m.MessageRewriterPage
})));
const PaymentPage = lazy(() => import('../pages/PaymentPage').then(m => ({
  default: m.PaymentPage
})));
const ReferralsPage = lazy(() => import('../pages/ReferralsPage').then(m => ({
  default: m.ReferralsPage
})));
export const protectedRoutes = <Fragment data-id="element-10626" data-mp="3eocf2r0sukbs">
    <Route path="/onboarding" element={<ProtectedRoute data-id="element-10628" data-mp="3jgvsnnzhlfgl">
          <OnboardingFlow data-id="element-10629" data-mp="3jhdud04x4lvw" />
        </ProtectedRoute>} data-id="element-10627" data-mp="3eoktwoghfzpm" />
    <Route path="/dashboard" element={<ProtectedRoute data-id="element-10631" data-mp="2m0yfsm9mpcoi">
          <DashboardPage data-id="element-10632" data-mp="2r0baft6qro1n" />
        </ProtectedRoute>} data-id="element-10630" data-mp="2m1rnpqkbq888" />
    <Route path="/dashboard/referrals" element={<ProtectedRoute data-id="element-10634" data-mp="3uafekq9ooyeq">
          <ReferralsPage data-id="element-10635" data-mp="3u9xibtn0uk6t" />
        </ProtectedRoute>} data-id="element-10633" data-mp="2qyqhg802sd5w" />
    <Route path="/upload" element={<ProtectedRoute data-id="element-10637" data-mp="3pbvrunn9nilb">
          <UploadPage data-id="element-10638" data-mp="6y4yehgizwqy" />
        </ProtectedRoute>} data-id="element-10636" data-mp="3pcnm9v54naa0" />
    <Route path="/analysis" element={<ProtectedRoute data-id="element-10640" data-mp="2wt6u6e3d1g4">
          <AnalysisPage data-id="element-10641" data-mp="2xm32dffc8k0" />
        </ProtectedRoute>} data-id="element-10639" data-mp="6xmt6vbvy86w" />
    <Route path="/tools" element={<ProtectedRoute data-id="element-10643" data-mp="3bd5v594czkxh">
          <PremiumToolsPage data-id="element-10644" data-mp="3begxd4i5okmh" />
        </ProtectedRoute>} data-id="element-10642" data-mp="3bccwkvfk01qf" />
    <Route path="/tools/rewriter" element={<ProtectedRoute data-id="element-10646" data-mp="3kd16pf1tthy1">
          <MessageRewriterPage data-id="element-10647" data-mp="3kdb07cm2y78h" />
        </ProtectedRoute>} data-id="element-10645" data-mp="36eb9lzf0bi9o" />
    <Route path="/premium-tools" element={<ProtectedRoute data-id="element-10649" data-mp="3fcenc9jr3aqx">
          <PremiumToolsPage data-id="element-10650" data-mp="3fgaux3x218if" />
        </ProtectedRoute>} data-id="element-10648" data-mp="3fdy4s3h57rua" />
    <Route path="/profile" element={<ProtectedRoute data-id="element-10652" data-mp="unqu2uxovtu7">
          <ProfilePage data-id="element-10653" data-mp="uoigbf5ecf7t" />
        </ProtectedRoute>} data-id="element-10651" data-mp="zlil7mqifbxc" />
    <Route path="/all-scans" element={<ProtectedRoute data-id="element-10655" data-mp="133ya6wks8dy9">
          <AllScansPage data-id="element-10656" data-mp="133g6xfzpczgu" />
        </ProtectedRoute>} data-id="element-10654" data-mp="uq39b0c2bq3k" />
    <Route path="/monthly-report" element={<ProtectedRoute data-id="element-10658" data-mp="t6jtcvuy5n5f">
          <MonthlyReportPage data-id="element-10659" data-mp="t73f6nnpwvoq" />
        </ProtectedRoute>} data-id="element-10657" data-mp="177e3pk1k1y6q" />
    <Route path="/settings" element={<ProtectedRoute data-id="element-10661" data-mp="y6ps0vzmw9x0">
          <SettingsPage data-id="element-10662" data-mp="y5wqc9fj8alq" />
        </ProtectedRoute>} data-id="element-10660" data-mp="t8wlu2ybzfwq" />
    <Route path="/payment" element={<ProtectedRoute data-id="element-10664" data-mp="1lxlcf81rg2u8">
          <PaymentPage data-id="element-10665" data-mp="1qu29irqxtrjg" />
        </ProtectedRoute>} data-id="element-10663" data-mp="1luz95klwk9ht" />
  </Fragment>;